// Translation between traditional global (dataLayer) and ES6 module structure.
// This avoids having to add a global to a bunch of scripts which otherwise would not need one

window.dataLayer = window.dataLayer || [];

export default window.dataLayer;
